<!--
  - Copyright (c) 2022.
  - ISNLab
  - Owner and rewriter: Sedov A. Sergey
  - sedov.sergey@isnlab.com
  -->

<template>
  <header class="app-header fixed-top">
    <div class="app-header-inner">
      <div class="container-fluid py-2">
        <div class="app-header-content">
          <div class="row justify-content-between align-items-center">

            <div class="col-auto">
              <a id="sidepanel-toggler" @click.prevent="toggleBar" class="sidepanel-toggler d-inline-block d-xl-none" href="#">
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" role="img">
                  <title>Menu</title>
                  <path stroke="currentColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2" d="M4 7h22M4 15h22M4 23h22"></path>
                </svg>
              </a>
            </div><!--//col-->


            <ProfileBlock v-if="isLoggedIn"></ProfileBlock>

          </div><!--//row-->
        </div><!--//app-header-content-->
      </div><!--//container-fluid-->
    </div><!--//app-header-inner-->
    <SidePanel :is-open="openSidebar" @doclose="doClose"></SidePanel>
  </header><!--//app-header-->
</template>

<script>
import SidePanel from "./SidePanel";
import { isLoggedIn } from "@/inc/storage";
import ProfileBlock from "@/components/layouts/ProfileBlock";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "HeaderBlock",
  components: {ProfileBlock, SidePanel},
  data(){
    return {
      openSidebar : false,
    }
  },
  mounted() {
    this.resize()
    window.addEventListener('resize', this.resize);
  },
  unmounted() {
    window.removeEventListener('resize', this.resize);
  },
  methods : {
    resize : function (){
      this.openSidebar = (window.innerWidth >= 1200)
    },
    toggleBar: function (){
      this.openSidebar = !this.openSidebar
    },
    doClose: function (){
      this.openSidebar = false
    },
    // eslint-disable-next-line no-unused-vars

  },
  setup(){
    return {
      isLoggedIn
    }
  }
}
</script>

<style scoped>

</style>